<template>
    <section class="container">
        <div class="relative overflow-hidden rounded-12 bg-[#FFFFFF0D]">
            <div
                class="relative z-10 flex p-3 max-md:flex-col md:items-end md:justify-between">
                <AtomTitle
                    class="w-full max-w-[16rem] text-20/120 lg:max-w-[26.375rem]">
                    Реализуем вашу задачу&nbsp;качественно и&nbsp;под&nbsp;ключ
                </AtomTitle>

                <AtomButton
                    class="h-min max-md:mt-5 max-md:w-full"
                    @click="openFeedbackModal">
                    Обсудить проект
                </AtomButton>
            </div>
            <BackgroundStarIcon
                class="absolute left-2/3 top-1/2 -translate-x-1/2 -translate-y-1/2 max-md:hidden md:left-[60%] md:max-w-[22rem] lg:max-w-[30rem] xl:max-w-[42rem]" />
            <FrontStarIcon
                class="absolute -top-10 right-1 aspect-square max-w-[6rem] md:left-[60%] md:top-1/2 md:max-w-[16rem] md:-translate-x-1/2 md:-translate-y-1/2 lg:max-w-[30rem] xl:max-w-[42rem]" />
            <div
                class="absolute -left-1/4 top-0 aspect-square w-1/2 -rotate-12 scale-100 rounded-full bg-accent/50 blur-[6rem]" />
        </div>
    </section>
</template>

<script setup lang="ts">
import type { Category } from '~/types/global.types'

import AtomButton from '~/components/atom/atom-button/AtomButton.vue'
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BackgroundStarIcon from '~/components/pages/portfolio/turnkey-implementation-section/BackgroundStarIcon.vue'
import FrontStarIcon from '~/components/pages/portfolio/turnkey-implementation-section/FrontStarIcon.vue'

const props = defineProps({
    categories: {
        type: Array as PropType<Category[]>,
        default: () => [],
    },
})

onMounted(() => {
    modalStore.setCategories(props.categories)
})

const modalStore = useModalStore()

function openFeedbackModal() {
    modalStore.setFormID(8)
    modalStore.setCategories(props.categories)
    modalStore.setFormName('Обсудить проект')
    modalStore.open('feedbackModal')
}
</script>
